export default __webpack_public_path__ + "static/media/winner4.c32a76f4.jpg";